import { Component, ElementRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { IHeaderAngularComp } from "ag-grid-angular";
import { IHeaderParams } from 'ag-grid-community'

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-control-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss']
})
export class CustomHeaderComponent implements IHeaderAngularComp {
  headerText: string;
  validationText: string;
  requiredForGMCS: string;
  iconClass: string;
  isRequired: boolean = false;
  public params: any;
  public ascSort: boolean = false;
  public descSort: boolean = false;
  public noSort: boolean = true;


  @ViewChild('menuButton', { read: ElementRef }) public menuButton;

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return false;
  }

  agInit(params: IHeaderParams): void {
    if (params.displayName) {
      this.params = params;
      this.parseDisplayName(params.displayName);
    }
    params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));

    this.onSortChanged();
  }

  private parseDisplayName(displayName: string) {
    if (displayName.includes('~')) {
      const parts = displayName.split('~');
      this.headerText = parts[0];
      this.validationText = parts[1];
      this.requiredForGMCS = parts[2];
      this.isRequired = this.isFieldRequired();
    } else {
      this.headerText = displayName;
    }
  }

  private isFieldRequired(): boolean {
    const hasRequired = (this.validationText && this.validationText.includes('Required')) ||
      (this.requiredForGMCS && this.requiredForGMCS.includes('Required'));
    if (!hasRequired) {
      return false;
    }
    const isGMCS = (this.validationText && this.validationText.includes('GMCS')) ||
      (this.requiredForGMCS && this.requiredForGMCS.includes('GMCS'));
    return !isGMCS;
  }

  onMenuClicked(event) {
    this.params.showColumnMenu(this.menuButton.nativeElement);
  };

  onSortChanged() {
    this.ascSort = this.descSort = false;
    this.noSort = true;
    if (this.params.column.isSortAscending()) {
      this.ascSort = true; this.descSort = false; this.noSort = false;
    } else if (this.params.column.isSortDescending()) {
      this.ascSort = false; this.descSort = true; this.noSort = false;
    } else {
      this.ascSort = false; this.descSort = false; this.noSort = true;
    }
  }

  onSortRequested(event: any) {
    let order: string = '';

    if (this.noSort && !this.ascSort) { this.ascSort = true; order = 'asc'; this.noSort = false; this.iconClass = 'ag-icon ag-icon-asc'; }
    else if (this.ascSort && !this.descSort) { this.descSort = true; this.noSort = false; order = 'desc'; this.ascSort = false; this.iconClass = 'ag-icon ag-icon-desc'; }
    else if (this.descSort) { this.noSort = true; order = ''; this.descSort = false; this.iconClass = ''; this.ascSort = false; }
    this.params.setSort(order, event.shiftKey);
  }
}